module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/admin/icons/home-b66fb0bd09f62470ea1d44b98195bf07.svg&quot;;"